<template>
    <button v-if="btnType === 100" type="button" class="button" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 120" type="button" class="button large" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 140" type="button" class="button normal" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 160" type="button" class="button small" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 180" type="button" class="button" @click="onClick" disabled>{{ props?.label }}</button>

    <!-- 100%버튼 : 비번입력, 변경하기, 진단평가 시작하기, 평가 시작,  -->
    <button v-if="btnType === 200" type="button" class="button full" @click="onClick">{{ props?.label }}</button>
    <!-- 100%버튼 : 러닝홈 아이콘 버튼  -->
    <button v-if="btnType === 210" type="button" class="button full button__icon" @click="onClick">
        <span class="button__txt">{{ props?.label }} </span><span class="button__img"><img src="/assets/images/icon/ico_main_right.svg" /></span>
    </button>
    <button v-if="btnType === 220" type="button" class="button full button__icon" disabled>
        <span class="button__txt">{{ props?.label }} </span><span class="button__img"></span>
    </button>

    <!-- 라운드 버튼   : -->
    <button v-if="btnType === 300" type="button" class="button round" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 400" type="button" class="button outline" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 415" type="button" class="button primary" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 420" type="button" class="button primary-outline" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 430" type="button" class="button secondary" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 440" type="button" class="button secondary-outline" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 450" type="button" class="button black" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 460" type="button" class="button black-outline" @click="onClick">{{ props?.label }}</button>

    <!-- 원형 버튼   : -->
    <button v-if="btnType === 310" type="button" class="button-back" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 320" type="button" class="button-next" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 330" type="button" class="button-up" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 340" type="button" class="button-down" @click="onClick">{{ props?.label }}</button>

    <!--  완료 버튼  : -->
    <button v-if="btnType === 350" type="button" class="button black round button-confirm" @click="onClick">{{ props?.label }}</button>

    <!--  ox 버튼  : -->
    <button v-if="btnType === 360" type="button" class="check-o" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 361" type="button" class="check-o2" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 370" type="button" class="check-x" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 380" type="button" class="color-check-o" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 390" type="button" class="color-check-x" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 391" type="button" class="check-wrong_o" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 392" type="button" class="check-wrong_x" @click="onClick">{{ props?.label }}</button>

    <!-- 396테두리만 블랙 : 분석리포트 홈 -->
    <button v-if="btnType === 462" type="button" class="button report__button black-outline" @click="onClick">{{ props?.label }}</button>

    <!-- 얇은 radius : 학습 기록 보기   -->
    <button v-if="btnType === 470" type="button" class="button small primary" style="width: 12vw" @click="onClick">{{ props?.label }}</button>
    <!-- 얇은 radius : 작품별 -->
    <button v-if="btnType === 471" type="button" class="button small black-outline" style="width: 12vw" @click="onClick">{{ props?.label }}</button>
    <!-- 얇은 radius : 아이콘+필터 선택 -->
    <button v-if="btnType === 472" type="button" class="button black-outline filter__btn" style="width: 12vw" @click="onClick">{{ props?.label }}</button>

    <!-- 얇은 radius : 내정보수정 -->
    <button v-if="btnType === 475" type="button" class="button small black-outline" @click="onClick">{{ props?.label }}</button>
    <!-- 필터선택 아이콘 버튼 : 작품별 -->
    <button v-if="btnType === 478" type="button" class="button black-outline filter__btn" @click="onClick">{{ props?.label }}</button>

    <!-- 600 긴 버튼 : 학습 홈으로 이동,  -->
    <button v-if="btnType === 500" type="button" class="button login__button" @click="onClick">{{ props?.label }}</button>

    <!-- 396짧은 버튼 : 목록으로(학습알림,공지사항), 튜토리얼 시작하기-->
    <button v-if="btnType === 550" type="button" class="button report__button" @click="onClick">{{ props?.label }}</button>

    <!-- 396짧은 버튼 블랙 :  진단평가완료-->
    <button v-if="btnType === 552" type="button" class="button black report__button" @click="onClick">{{ props?.label }}</button>

    <!-- 396짧은 버튼 : 필터하단 -->
    <button v-if="btnType === 560" type="button" class="button full large" @click="onClick">{{ props?.label }}</button>

    <!-- 라운드 블랙 or투명 버튼 : 학습알림, 공지사항, 맞춤학습 오답노트, 수능모의평가 오답노트  -->
    <button v-if="btnType === 570" type="button" class="button normal black round" @click="onClick">{{ props?.label }}</button>
    <button v-if="btnType === 580" type="button" class="button normal transparent-outline round" @click="onClick">{{ props?.label }}</button>
</template>

<script setup>
import { onMounted, ref, watch, computed, defineEmits } from 'vue';

const props = defineProps({
    type: {
        default: 100,
    },
    label: {
        default: 'BTN',
    },
});
const emit = defineEmits(['onReturn']);

const btnType = computed(() => {
    return props?.type;
});

let isValidBtn = true;
const onClick = () => {
    // console.log('--onClick  --isValidBtn', isValidBtn);
    if (isValidBtn) {
        isValidBtn = false;
        emit('onReturn');
        setTimeout(() => {
            // console.log('--onClick  -isValidBtn-', isValidBtn);
            isValidBtn = true;
        }, 500);
    }
    // console.log('--onClick  --', props.label);
};
// onMounted(() => {});
</script>

<style scoped lang="scss"></style>
